export default __webpack_public_path__ + "static/media/1.4bcb9593.png";